import React, { Suspense } from 'react';
import { Loading } from 'src/components/shared/Loading';
import { LoadingFailed } from 'src/components/shared/LoadingFailed';
import { NewspaperTopPageLayout } from './common/NewspaperTopPageLayout';

const Newspaper = React.lazy(() => import('./Newspaper'));

export default class extends React.Component<Record<string, unknown>, { hasError?: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }
  public render() {
    if (this.state.hasError) {
      return (
        <NewspaperTopPageLayout>
          <LoadingFailed error="unstable-network" />
        </NewspaperTopPageLayout>
      );
    } else {
      return (
        <Suspense
          fallback={
            <NewspaperTopPageLayout>
              <Loading />
            </NewspaperTopPageLayout>
          }
        >
          <Newspaper />
        </Suspense>
      );
    }
  }
}
